import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-start-questionnaire',
    templateUrl: './start-questionnaire.component.html',
    styleUrls: ['./start-questionnaire.component.scss'],
    standalone: false,
})
export class StartQuestionnaireComponent {
    @Output() emitStartQuestionnaire = new EventEmitter();

    constructor() {}

    /* Function created to emit the event when the Start button is clicked */
    startQuestionnaire() {
        this.emitStartQuestionnaire.emit(true);
    }
}
